module.exports = "<nav class=\"navbar navbar-expand-md navbar-bluw bg-blue fixed-top\">\n    <a href=\"/\">\n    </a>\n </nav>"


//////////////////
// WEBPACK FOOTER
// C:/Users/tormo/Documents/InterNova/Kunder/Mattilsynet/plvmWEB/webapp/src/app/navbar/navbar.component.html
// module id = ../../../../../src/app/navbar/navbar.component.html
// module chunks = main